import React from 'react'

import './style.css';

function Footer() {
  return (
    <footer className="footer">
      <h6 className="footer-title">Nobody hopes that you know everything, only amuse yourself and never stop learning.</h6>
      <span className="footer-name">Developed by Henry Zarza</span>
    </footer>
  )
}

export default Footer;
